"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChatStatus = getChatStatus;
exports.setChatStatus = setChatStatus;
var _localStorage = require("../../../Helpers/localStorage");
/* global window */

function setChatStatus(status) {
  if ((0, _localStorage.supportLocalStorage)()) {
    window.localStorage.setItem('__CHAT_SERVICE_STATUS', status.toString());
  }
}
function getChatStatus() {
  if ((0, _localStorage.supportLocalStorage)()) {
    var status = window.localStorage.getItem('__CHAT_SERVICE_STATUS');
    if (status) {
      return status === 'true';
    }
  }
  return true;
}